import { useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { useViewport } from 'src/hooks/useViewport';
import UnauthorizedContainWrapper from '../UnauthorizedContainWrapper';
import 'react-pdf/dist/umd/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const useStyles = makeStyles(() =>
  createStyles({
    mainContainer: {
      width: '100%',
      maxWidth: 1600,
      margin: 'auto',
      padding: '0 16px 40px',
      overflow: 'hidden',

      '@media screen and (min-width: 768px)': {
        padding: '0 100px 40px',
      },
    },
  })
);

export default function Spotify() {
  const classes = useStyles();
  const { width } = useViewport();
  const [numPages, setNumPages] = useState<number[]>([]);

  const pageWidth = Math.min(width - 32, 1400);

  const handleDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(new Array(numPages).fill(0).map((_, index) => index + 1));
  };

  return (
    <UnauthorizedContainWrapper>
      <div className={classes.mainContainer}>
        <Document
          file='./Spotify.pdf'
          externalLinkTarget='_blank'
          onLoadSuccess={handleDocumentLoadSuccess}
        >
          {numPages.map((page) => (
            <div key={page} id={`spotify-page-${page}`}>
              <Page width={pageWidth} pageNumber={page} />
            </div>
          ))}
        </Document>
      </div>
    </UnauthorizedContainWrapper>
  );
}
